(function () {
  'use strict';

  function getProductForm() {
    return document.querySelector('form[action^="/cart/add"]');
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href="#"]');
    if (!link) return;

    var form = getProductForm();
    if (!form) return;

    // Skip links that live inside the product form itself
    if (form.contains(link)) return;

    event.preventDefault();

    var submitButton = form.querySelector('[type="submit"]');

    if (typeof form.requestSubmit === 'function') {
      // requestSubmit fires a real, trusted submit event with the submitter set,
      // so Dawn's ProductForm AJAX handler, Shopify Web Pixels, and Meta Pixel
      // all see a native form submission - no synthetic .click(), no stopPropagation.
      form.requestSubmit(submitButton || undefined);
    } else {
      // Fallback for browsers without requestSubmit (older Safari).
      // Dispatching a submit event lets Dawn intercept it via AJAX
      // rather than triggering a full-page navigation via form.submit().
      form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }
  });
})();
